/**
 * SA Shop Device Comparison: mobile dropdowns, sticky header, variant switch, height equalize.
 * Scope: queries only within section wrapper.
 */
(function() {
  const CARD_SEL = '.sa-shop-device-comparison__card';
  const SELECTS_SEL = '.sa-shop-device-comparison__selects';
  const TABLE_CELL_SEL = '.js-dc-table-cell';
  const TABLE_ROW_SEL = '.sa-shop-device-comparison__table-row';
  const CARD_SELECT_SLOT_SEL = '.js-dc-card-select-slot';
  const HIDDEN_CARD = 'sa-shop-device-comparison__card--hidden';
  const HIDDEN_CELL = 'sa-shop-device-comparison__table-cell--hidden';
  const HIDDEN_ROW = 'sa-shop-device-comparison__table-row--hidden';
  const NO_BORDER_ROW = 'sa-shop-device-comparison__table-row--no-border';
  const MOBILE_INIT = 'sa-shop-dc-mobile-initialized';
  const COLLAPSED = 'sa-shop-dc-collapsed';

  function SaShopDeviceComparison(sectionWrapper, sectionId) {
    this.sectionWrapper = sectionWrapper;
    this.sectionId = sectionId || '';
    this.mobileBreakpoint = 992;
    this.select1Els = Array.from(sectionWrapper.querySelectorAll('.js-dc-select-1'));
    this.select2Els = Array.from(sectionWrapper.querySelectorAll('.js-dc-select-2'));
    this.headerSelectsWrapper = sectionWrapper.querySelector('.sa-shop-device-comparison__header ' + SELECTS_SEL);
    this.headerSelectWrap1 = this.headerSelectsWrapper ? this.headerSelectsWrapper.querySelector('.js-dc-select-1') : null;
    this.headerSelectWrap2 = this.headerSelectsWrapper ? this.headerSelectsWrapper.querySelector('.js-dc-select-2') : null;
    this.headerSelectWrap1 = this.headerSelectWrap1 ? this.headerSelectWrap1.closest('.sa-shop-device-comparison__select-wrap') : null;
    this.headerSelectWrap2 = this.headerSelectWrap2 ? this.headerSelectWrap2.closest('.sa-shop-device-comparison__select-wrap') : null;
    this.allProducts = [];
    this.productCards = {};
    this.productVariants = {};
    this.headerEl = sectionWrapper.querySelector('.sa-shop-device-comparison__header');
    this.stickyEl = sectionWrapper.querySelector('.sa-shop-device-comparison__sticky');
    this.controlsEl = sectionWrapper.querySelector('.sa-shop-device-comparison__controls');
    this.toggleBtn = this.controlsEl ? this.controlsEl.querySelector('.js-dc-toggle') : null;
    this.stickyProductsEl = this.stickyEl ? this.stickyEl.querySelector('.sa-shop-device-comparison__products') : null;
    this.stickyThreshold = 0;
    this.stickyEndThreshold = Infinity;
    this._boundScroll = this.onScroll.bind(this);
    this.moreBtn = sectionWrapper.querySelector('.js-dc-more-btn');
    this.initialRows = parseInt(sectionWrapper.getAttribute('data-initial-rows') || '6', 10);
    if (!this.initialRows || this.initialRows < 1) this.initialRows = 6;
    this.allRows = [];
    this.isExpanded = false;
    this.tablesEl = sectionWrapper.querySelector('.sa-shop-device-comparison__tables');
  }

  SaShopDeviceComparison.prototype.initTableRowsVisibility = function() {
    const rows = Array.from(this.sectionWrapper.querySelectorAll(TABLE_ROW_SEL));
    this.allRows = rows;
    const limit = this.initialRows;
    rows.forEach(function(row) {
      row.classList.remove(HIDDEN_ROW);
      row.classList.remove(NO_BORDER_ROW);
    });
    rows.forEach(function(row, index) {
      if (index >= limit) row.classList.add(HIDDEN_ROW);
    });
    if (rows.length > limit && limit > 0) {
      var lastVisibleIndex = limit - 1;
      if (rows[lastVisibleIndex]) rows[lastVisibleIndex].classList.add(NO_BORDER_ROW);
    }
    if (this.moreBtn) {
      const hasMore = rows.length > limit;
      this.moreBtn.style.display = hasMore ? '' : 'none';
    }
  };

  SaShopDeviceComparison.prototype.handleMoreClick = function() {
    if (!this.allRows || !this.allRows.length) return;
    this.isExpanded = !this.isExpanded;
    var self = this;
    if (this.isExpanded) {
      this.allRows.forEach(function(row) {
        row.classList.remove(HIDDEN_ROW);
        row.classList.remove(NO_BORDER_ROW);
      });
      if (this.tablesEl) this.tablesEl.classList.add('sa-shop-dc-tables-expanded');
      if (this.moreBtn) {
        this.moreBtn.textContent = this.moreBtn.getAttribute('data-less-text') || 'Show Less';
      }
    } else {
      var limit = this.initialRows;
      this.allRows.forEach(function(row) {
        row.classList.remove(HIDDEN_ROW);
        row.classList.remove(NO_BORDER_ROW);
      });
      this.allRows.forEach(function(row, index) {
        if (index >= limit) row.classList.add(HIDDEN_ROW);
      });
      if (this.allRows.length > limit && limit > 0 && this.allRows[limit - 1]) {
        this.allRows[limit - 1].classList.add(NO_BORDER_ROW);
      }
      if (this.tablesEl) this.tablesEl.classList.remove('sa-shop-dc-tables-expanded');
      if (this.moreBtn) {
        this.moreBtn.textContent = this.moreBtn.getAttribute('data-more-text') || 'Learn More';
      }
    }
  };

  SaShopDeviceComparison.prototype.getSelectedPairValues = function() {
    const s1 = this.select1Els && this.select1Els[0] ? this.select1Els[0].value : '';
    const s2 = this.select2Els && this.select2Els[0] ? this.select2Els[0].value : '';
    return { selected1: s1, selected2: s2 };
  };

  SaShopDeviceComparison.prototype.getHeaderVisibleCardsOrdered = function() {
    const cards = Array.from(this.sectionWrapper.querySelectorAll('.sa-shop-device-comparison__header ' + CARD_SEL));
    const visible = cards.filter(function(card) { return !card.classList.contains(HIDDEN_CARD); });
    visible.sort(function(a, b) {
      const oa = parseInt(a.style.order || '0', 10);
      const ob = parseInt(b.style.order || '0', 10);
      return oa - ob;
    });
    return visible;
  };

  SaShopDeviceComparison.prototype.restoreHeaderSelects = function() {
    if (!this.headerSelectsWrapper) return;
    if (this.headerSelectWrap1 && this.headerSelectWrap1.parentElement !== this.headerSelectsWrapper) {
      this.headerSelectsWrapper.appendChild(this.headerSelectWrap1);
    }
    if (this.headerSelectWrap2 && this.headerSelectWrap2.parentElement !== this.headerSelectsWrapper) {
      this.headerSelectsWrapper.appendChild(this.headerSelectWrap2);
    }
  };

  SaShopDeviceComparison.prototype.mountMobileSelectsIntoCards = function() {
    if (!this.headerSelectsWrapper || !this.headerSelectWrap1 || !this.headerSelectWrap2) return;
    const cards = this.getHeaderVisibleCardsOrdered();
    const card1 = cards[0];
    const card2 = cards[1];
    const slot1 = card1 ? card1.querySelector(CARD_SELECT_SLOT_SEL) : null;
    const slot2 = card2 ? card2.querySelector(CARD_SELECT_SLOT_SEL) : null;
    if (slot1 && this.headerSelectWrap1.parentElement !== slot1) slot1.appendChild(this.headerSelectWrap1);
    if (slot2 && this.headerSelectWrap2.parentElement !== slot2) slot2.appendChild(this.headerSelectWrap2);
  };

  SaShopDeviceComparison.prototype.getAllProducts = function() {
    const cards = Array.from(this.sectionWrapper.querySelectorAll(CARD_SEL));
    const map = {};
    cards.forEach(function(card) {
      const rawId = card.dataset.productId || card.getAttribute('data-product-id') || card.getAttribute('data-block-id') || '';
      if (!rawId) return;
      const titleEl = card.querySelector('.sa-shop-device-comparison__card-title') || card.querySelector('.sa-shop-device-comparison__stick-title');
      const title = titleEl ? titleEl.textContent.trim() : '';
      if (!map[rawId]) map[rawId] = { id: rawId, title: title || rawId };
      else if ((map[rawId].title === rawId || !map[rawId].title) && title) map[rawId].title = title;
    });
    return Object.values(map);
  };

  SaShopDeviceComparison.prototype.updateItems = function(selectedId1, selectedId2) {
    const allItems = this.sectionWrapper.querySelectorAll(TABLE_CELL_SEL);
    allItems.forEach(function(item) {
      const productId = item.dataset.productId;
      if (productId === selectedId1) {
        item.classList.remove(HIDDEN_CELL);
        item.style.order = '1';
      } else if (productId === selectedId2) {
        item.classList.remove(HIDDEN_CELL);
        item.style.order = '2';
      } else {
        item.classList.add(HIDDEN_CELL);
        item.style.order = '3';
      }
    });
    const productCards = this.sectionWrapper.querySelectorAll(CARD_SEL);
    productCards.forEach(function(card) {
      const productId = card.dataset.productId || card.getAttribute('data-product-id') || card.getAttribute('data-block-id') || '';
      if (productId === selectedId1) {
        card.classList.remove(HIDDEN_CARD);
        card.style.order = '1';
      } else if (productId === selectedId2) {
        card.classList.remove(HIDDEN_CARD);
        card.style.order = '2';
      } else {
        card.classList.add(HIDDEN_CARD);
        card.style.order = '3';
      }
    });
  };

  SaShopDeviceComparison.prototype.updateMobileColumnColors = function(selectedId1, selectedId2) {
    if (window.innerWidth > this.mobileBreakpoint) return;
    var getColor = function(pid) {
      if (!pid) return '';
      var el = this.sectionWrapper.querySelector(TABLE_CELL_SEL + '[data-product-id="' + pid + '"]');
      if (!el) return '';
      var inline = el.style.getPropertyValue('--sa-shop-dc-col-color');
      if (inline) return inline.trim();
      var cs = window.getComputedStyle(el);
      var v = cs.getPropertyValue('--sa-shop-dc-col-color');
      return (v || '').trim();
    }.bind(this);

    var c1 = getColor(selectedId1) || 'transparent';
    var c2 = getColor(selectedId2) || 'transparent';
    this.sectionWrapper.style.setProperty('--sa-shop-dc-col-color-1', c1);
    this.sectionWrapper.style.setProperty('--sa-shop-dc-col-color-2', c2);
  };

  SaShopDeviceComparison.prototype.updateSelectOptions = function(selectToUpdate, currentValue, otherSelectValue) {
    var prevValue = currentValue || selectToUpdate.value;
    selectToUpdate.innerHTML = '';
    this.allProducts.forEach(function(prod) {
      if (prod.id === otherSelectValue) return;
      selectToUpdate.add(new Option(prod.title || prod.id, prod.id));
    });
    selectToUpdate.value = prevValue;
  };

  SaShopDeviceComparison.prototype.handleSelectionChange = function(selected1, selected2) {
    if (!selected1 || !selected2) {
      const current = this.getSelectedPairValues();
      selected1 = current.selected1;
      selected2 = current.selected2;
    }
    const self = this;
    this.select1Els.forEach(function(s) {
      self.updateSelectOptions(s, selected1, selected2);
    });
    this.select2Els.forEach(function(s) {
      self.updateSelectOptions(s, selected2, selected1);
    });
    if (window.innerWidth <= this.mobileBreakpoint) {
      this.updateItems(selected1, selected2);
      this.mountMobileSelectsIntoCards();
      this.updateMobileColumnColors(selected1, selected2);
    }
    this.equalizeProductCardHeights();
  };

  SaShopDeviceComparison.prototype.handleViewChange = function() {
    const isMobile = window.innerWidth <= this.mobileBreakpoint;
    const allItems = this.sectionWrapper.querySelectorAll(TABLE_CELL_SEL);
    const productCards = this.sectionWrapper.querySelectorAll(CARD_SEL);
    if (isMobile) {
      const current = this.getSelectedPairValues();
      this.handleSelectionChange(current.selected1, current.selected2);
      this.sectionWrapper.classList.add(MOBILE_INIT);
      if (this.stickyEl) this.stickyEl.classList.remove(COLLAPSED);
      if (this.toggleBtn) this.toggleBtn.textContent = this.toggleBtn.dataset.constrict || this.toggleBtn.textContent;
      this.updateStickyProductsHeight();
    } else {
      this.sectionWrapper.classList.remove(MOBILE_INIT);
      allItems.forEach(function(item) {
        item.classList.remove(HIDDEN_CELL);
        item.style.order = '';
      });
      productCards.forEach(function(card) {
        card.classList.remove(HIDDEN_CARD);
        card.style.order = '';
      });
      if (this.stickyEl) this.stickyEl.classList.remove(COLLAPSED);
      if (this.stickyEl) this.stickyEl.style.removeProperty('--sa-shop-dc-products-h');
      this.restoreHeaderSelects();
    }
    this.updateStickyThreshold();
    this.onScroll();
  };

  SaShopDeviceComparison.prototype.populateSelects = function() {
    const self = this;
    this.select1Els.forEach(function(s) { s.innerHTML = ''; });
    this.select2Els.forEach(function(s) { s.innerHTML = ''; });
    this.allProducts.forEach(function(prod) {
      const title = prod.title || prod.id;
      self.select1Els.forEach(function(s) { s.add(new Option(title, prod.id)); });
      self.select2Els.forEach(function(s) { s.add(new Option(title, prod.id)); });
    });
    if (this.allProducts.length > 1) {
      const v1 = this.allProducts[0].id;
      const v2 = this.allProducts[1].id;
      this.select1Els.forEach(function(s) { s.value = v1; });
      this.select2Els.forEach(function(s) { s.value = v2; });
    } else if (this.allProducts.length === 1) {
      const v1 = this.allProducts[0].id;
      this.select1Els.forEach(function(s) { s.value = v1; });
    }
  };

  SaShopDeviceComparison.prototype.setupProductCards = function() {
    const cards = this.sectionWrapper.querySelectorAll(CARD_SEL);
    const self = this;
    cards.forEach(function(card) {
      const productId = card.dataset.productId || card.getAttribute('data-product-id') || card.getAttribute('data-block-id') || '';
      if (!productId) return;
      const variantsEl = card.querySelector('.js-dc-variants-json');
      if (!variantsEl) return;
      var variants = [];
      try { variants = JSON.parse(variantsEl.textContent || '[]'); } catch (e) { variants = []; }
      if (!self.productCards[productId]) self.productCards[productId] = [];
      self.productCards[productId].push(card);
      self.productVariants[productId] = variants;
    });

    this.setActiveVariantForProduct = function(productId, variantId) {
      const variants = self.productVariants[productId] || [];
      const vData = variants.find(function(v) { return String(v.id) === String(variantId); }) || variants[0];
      const cardsOfProduct = self.productCards[productId] || [];
      if (!vData) return;
      cardsOfProduct.forEach(function(card) {
        const imageEl = card.querySelector('.js-dc-product-image');
        const stickImageEl = card.querySelector('.sa-shop-device-comparison__stick-image img');
        const priceCurrentEl = card.querySelector('.js-dc-price-current');
        const priceCompareEl = card.querySelector('.js-dc-price-compare');
        const stickPriceCurrentEl = card.querySelector('.js-dc-stick-price-current');
        const stickPriceCompareEl = card.querySelector('.js-dc-stick-price-compare');
        const hideOriginal = (card.dataset.hideOriginalPrice === 'true');
        const priceCurrentContainer = priceCurrentEl ? priceCurrentEl.closest('.sa-shop-device-comparison__price-row') : null;
        const priceCompareContainer = priceCompareEl ? priceCompareEl.closest('.sa-shop-device-comparison__price-row') : null;
        const stickPriceCurrentContainer = stickPriceCurrentEl ? stickPriceCurrentEl.parentElement : null;
        const stickPriceCompareContainer = stickPriceCompareEl ? stickPriceCompareEl.parentElement : null;
        const priceCurrentPsEl = priceCurrentContainer ? priceCurrentContainer.querySelector('.sa-shop-device-comparison__price-ps') : null;
        const priceComparePsEl = priceCompareContainer ? priceCompareContainer.querySelector('.sa-shop-device-comparison__price-ps') : null;
        const stickPriceCurrentPsEl = stickPriceCurrentContainer ? stickPriceCurrentContainer.querySelector('.sa-shop-device-comparison__stick-price-ps') : null;
        const stickPriceComparePsEl = stickPriceCompareContainer ? stickPriceCompareContainer.querySelector('.sa-shop-device-comparison__stick-price-ps') : null;
        const formEls = card.querySelectorAll('.js-dc-product-form');

        card.querySelectorAll('.js-dc-variant').forEach(function(v) {
          v.classList.toggle('sa-shop-device-comparison__variant--active', v.dataset.variantId === String(variantId));
        });

        if (imageEl && vData.image) imageEl.src = vData.image;
        if (stickImageEl && vData.image) stickImageEl.src = vData.image;

        var priceText = vData.price_formatted;
        var compareText = vData.compare_at_price_formatted;
        if (priceCurrentEl) priceCurrentEl.textContent = priceText;
        if (stickPriceCurrentEl) stickPriceCurrentEl.textContent = priceText;

        if (priceCompareEl) {
          if (!hideOriginal && vData.compare_at_price && vData.compare_at_price > vData.price) {
            priceCompareEl.textContent = compareText;
            if (priceCompareContainer) priceCompareContainer.style.display = '';
            else priceCompareEl.style.display = '';
            if (priceCurrentPsEl) priceCurrentPsEl.style.display = '';
            if (priceComparePsEl) priceComparePsEl.style.display = '';
            if (stickPriceCompareEl) stickPriceCompareEl.textContent = compareText;
            if (stickPriceCompareContainer) stickPriceCompareContainer.style.display = '';
            else if (stickPriceCompareEl) stickPriceCompareEl.style.display = '';
            if (stickPriceCurrentPsEl) stickPriceCurrentPsEl.style.display = '';
            if (stickPriceComparePsEl) stickPriceComparePsEl.style.display = '';
          } else {
            if (priceCompareContainer) priceCompareContainer.style.display = 'none';
            else priceCompareEl.style.display = 'none';
            if (priceCurrentPsEl) priceCurrentPsEl.style.display = 'none';
            if (priceComparePsEl) priceComparePsEl.style.display = 'none';
            if (stickPriceCompareContainer) stickPriceCompareContainer.style.display = 'none';
            else if (stickPriceCompareEl) stickPriceCompareEl.style.display = 'none';
            if (stickPriceCurrentPsEl) stickPriceCurrentPsEl.style.display = 'none';
            if (stickPriceComparePsEl) stickPriceComparePsEl.style.display = 'none';
          }
        }

        formEls.forEach(function(formEl) {
          const inputIdEl = formEl.querySelector('input[name="id"]');
          const primaryBtn = formEl.querySelector('.js-dc-btn-primary');
          const soldOutLabel = primaryBtn ? primaryBtn.getAttribute('data-sold-out-label') || 'Out of Stock' : 'Out of Stock';
          const availableLabel = primaryBtn ? primaryBtn.getAttribute('data-available-label') || (primaryBtn.textContent || '') : '';
          if (inputIdEl) inputIdEl.value = String(vData.id);
          if (primaryBtn) {
            if (vData.available) {
              primaryBtn.disabled = false;
              primaryBtn.textContent = availableLabel;
              primaryBtn.classList.remove('sa-shop-device-comparison__btn--disabled');
            } else {
              primaryBtn.disabled = true;
              primaryBtn.textContent = soldOutLabel;
              primaryBtn.classList.add('sa-shop-device-comparison__btn--disabled');
            }
          }
        });
      });
      self.equalizeProductCardHeights();
    };

    Object.keys(this.productCards).forEach(function(pid) {
      const firstCard = self.productCards[pid] && self.productCards[pid][0];
      if (!firstCard) return;
      const firstFormInput = firstCard.querySelector('.js-dc-product-form input[name="id"]');
      const variants = self.productVariants[pid] || [];
      const initialId = (firstFormInput && firstFormInput.value) || (variants[0] && String(variants[0].id));
      if (initialId) self.setActiveVariantForProduct(pid, initialId);
    });

    cards.forEach(function(card) {
      const productId = card.dataset.productId || card.getAttribute('data-product-id') || card.getAttribute('data-block-id') || '';
      const variantBtns = card.querySelectorAll('.js-dc-variant');
      if (variantBtns.length) {
        variantBtns.forEach(function(btn) {
          btn.addEventListener('click', function() { self.setActiveVariantForProduct(productId, btn.dataset.variantId); });
        });
      }
    });
  };

  SaShopDeviceComparison.prototype.updateStickyThreshold = function() {
    if (!this.headerEl) { this.stickyThreshold = 0; this.stickyEndThreshold = Infinity; return; }
    var y = window.pageYOffset || window.scrollY || 0;
    var headerRect = this.headerEl.getBoundingClientRect();
    var sectionRect = this.sectionWrapper.getBoundingClientRect();
    this.stickyThreshold = y + headerRect.top + headerRect.height * 0.5;
    var sectionBottom = y + sectionRect.top + sectionRect.height;
    var stickyH = this.stickyEl ? this.stickyEl.offsetHeight : 0;
    this.stickyEndThreshold = sectionBottom - stickyH;
  };

  SaShopDeviceComparison.prototype.onScroll = function() {
    if (!this.stickyEl) return;
    var y = window.pageYOffset || window.scrollY || 0;
    var active = y >= this.stickyThreshold && y < this.stickyEndThreshold;
    this.stickyEl.classList.toggle('active', active);
  };

  SaShopDeviceComparison.prototype.equalizeProductCardHeights = function() {
    const isMobile = window.innerWidth <= this.mobileBreakpoint;
    const resetInline = function(els) { els.forEach(function(el) { el.style.minHeight = ''; el.style.height = ''; }); };
    const header = this.sectionWrapper.querySelector('.sa-shop-device-comparison__header');
    if (!header) return;
    this.ensurePlaceholdersForEqualize(isMobile);
    const line1Els = Array.from(header.querySelectorAll(CARD_SEL + ' .sa-shop-device-comparison__card-line1'));
    const variantsEls = Array.from(header.querySelectorAll(CARD_SEL + ' .sa-shop-device-comparison__card-variants'));
    if (!line1Els.length && !variantsEls.length) return;
    resetInline(line1Els);
    resetInline(variantsEls);
    var maxLine1 = 0;
    var maxVariants = 0;
    line1Els.forEach(function(el) { maxLine1 = Math.max(maxLine1, el.offsetHeight || 0); });
    variantsEls.forEach(function(el) { maxVariants = Math.max(maxVariants, el.offsetHeight || 0); });
    line1Els.forEach(function(el) { el.style.minHeight = (maxLine1 || 0) + 'px'; });
    variantsEls.forEach(function(el) { el.style.minHeight = (maxVariants || 0) + 'px'; });
  };

  SaShopDeviceComparison.prototype.ensurePlaceholdersForEqualize = function(isMobile) {
    const header = this.sectionWrapper.querySelector('.sa-shop-device-comparison__header');
    if (!header) return;
    const cards = Array.from(header.querySelectorAll(CARD_SEL));
    cards.forEach(function(card) {
      var info = card.querySelector('.sa-shop-device-comparison__card-info');
      var line1 = card.querySelector('.sa-shop-device-comparison__card-line1');
      if (!line1 && info) {
        var ph = document.createElement('p');
        ph.className = 'sa-shop-device-comparison__card-line1 sa-shop-device-comparison__card-line1--placeholder';
        ph.setAttribute('aria-hidden', 'true');
        info.appendChild(ph);
      }
      var variants = card.querySelector('.sa-shop-device-comparison__card-variants');
      var media = card.querySelector('.sa-shop-device-comparison__card-media');
      if (!variants && media) {
        var vPh = document.createElement('ul');
        vPh.className = 'sa-shop-device-comparison__card-variants sa-shop-device-comparison__card-variants--placeholder';
        vPh.setAttribute('role', 'group');
        vPh.setAttribute('aria-hidden', 'true');
        media.appendChild(vPh);
      }
    });
  };

  SaShopDeviceComparison.prototype.updateStickyProductsHeight = function() {
    if (!this.stickyProductsEl) return;
    if (window.innerWidth > this.mobileBreakpoint) return;
    var h = this.stickyProductsEl.scrollHeight;
    this.stickyEl.style.setProperty('--sa-shop-dc-products-h', h + 'px');
    this.updateStickyThreshold();
  };

  SaShopDeviceComparison.prototype.handleToggleClick = function() {
    if (!this.stickyEl) return;
    if (window.innerWidth > this.mobileBreakpoint) return;
    var wasCollapsed = this.stickyEl.classList.contains(COLLAPSED);
    if (wasCollapsed) {
      this.stickyEl.classList.remove(COLLAPSED);
      this.updateStickyProductsHeight();
    } else {
      this.updateStickyProductsHeight();
      this.stickyEl.classList.add(COLLAPSED);
    }
    this.updateStickyThreshold();
    var collapsed = this.stickyEl.classList.contains(COLLAPSED);
    if (this.toggleBtn) {
      var expandText = this.toggleBtn.dataset.expand || this.toggleBtn.textContent;
      var constrictText = this.toggleBtn.dataset.constrict || this.toggleBtn.textContent;
      this.toggleBtn.textContent = collapsed ? expandText : constrictText;
    }
  };

  SaShopDeviceComparison.prototype.init = function() {
    this.initTableRowsVisibility();
    this.setupProductCards();
    if (!this.select1Els.length || !this.select2Els.length) {
      this.updateStickyThreshold();
      this.onScroll();
      window.addEventListener('scroll', this._boundScroll);
      if (this.moreBtn) this.moreBtn.addEventListener('click', this.handleMoreClick.bind(this));
      this.equalizeProductCardHeights();
      window.addEventListener('resize', this.equalizeProductCardHeights.bind(this));
      window.addEventListener('load', this.equalizeProductCardHeights.bind(this));
      return;
    }
    this.allProducts = this.getAllProducts();
    this.populateSelects();
    this.handleViewChange();
    var self = this;
    var setOpenState = function(selectEl, isOpen) {
      if (!selectEl) return;
      var wrap = selectEl.closest('.sa-shop-device-comparison__select-wrap');
      if (!wrap) return;
      wrap.classList.toggle('sa-shop-device-comparison__select-wrap--open', !!isOpen);
    };
    var onAnySelectChange = function(e) {
      setOpenState(e.target, false);
      var wrapper = e.target.closest('.sa-shop-device-comparison__selects');
      var otherSelect = wrapper ? wrapper.querySelector(e.target.classList.contains('js-dc-select-1') ? '.js-dc-select-2' : '.js-dc-select-1') : null;
      var selected1 = e.target.classList.contains('js-dc-select-1') ? e.target.value : (otherSelect ? otherSelect.value : self.getSelectedPairValues().selected1);
      var selected2 = e.target.classList.contains('js-dc-select-2') ? e.target.value : (otherSelect ? otherSelect.value : self.getSelectedPairValues().selected2);
      self.handleSelectionChange(selected1, selected2);
    };
    var bindSelect = function(s) {
      s.addEventListener('change', onAnySelectChange);
      s.addEventListener('focus', function() { setOpenState(s, true); });
      s.addEventListener('blur', function() { setOpenState(s, false); });
    };
    this.select1Els.forEach(bindSelect);
    this.select2Els.forEach(bindSelect);
    window.addEventListener('resize', this.handleViewChange.bind(this));
    this.updateStickyThreshold();
    this.onScroll();
    window.addEventListener('scroll', this._boundScroll);
    if (this.toggleBtn) this.toggleBtn.addEventListener('click', this.handleToggleClick.bind(this));
    if (this.moreBtn) this.moreBtn.addEventListener('click', this.handleMoreClick.bind(this));
    this.equalizeProductCardHeights();
    window.addEventListener('resize', this.equalizeProductCardHeights.bind(this));
    window.addEventListener('load', this.equalizeProductCardHeights.bind(this));
  };

  window.SaShopDeviceComparison = SaShopDeviceComparison;
  window.initSaShopDeviceComparison = function(sectionId) {
    var wrapper = document.getElementById('sa-shop-device-comparison-' + sectionId);
    if (!wrapper) return null;
    var instance = new SaShopDeviceComparison(wrapper, sectionId);
    instance.init();
    return instance;
  };
})();
